import { Popover } from "@/components/ui/popover";
import { Checkbox } from "@/components/atoms/Checkbox";
import { MultiSelectDropdownProps } from "./MultiSelectDropdown.types";
import { cn } from "@/utils/cn";

const neumorphStyles =
    "border border-[--color-neutral] dark:border-[--color-neutral-dark] dark:bg-[--secondary-900] dark:text-white";

export const MultiSelectDropdown = <T,>({
    label,
    options,
    value,
    onChange,
    selectLimit,
}: MultiSelectDropdownProps<T>) => {
    const handleToggle = (val: T) => {
        const already = value.includes(val);
        let next: T[];
        if (already) {
            next = value.filter((v) => v !== val);
        } else {
            if (selectLimit && value.length >= selectLimit) return;
            next = [...value, val];
        }
        onChange(next);
    };

    const displayText = (() => {
        if (value.length === 0) return "Seleccionar...";
        if (value.length > 3) return `${value.length} opciones`;
        return options
            .filter((o) => value.includes(o.value))
            .map((o) => o.label)
            .join(", ");
    })();

    return (
        <div>
            {label && <label className="block text-sm font-medium mb-1">{label}</label>}

            <Popover
                className={neumorphStyles}
                trigger={
                    <div
                        className={cn(
                            "p-2 rounded cursor-pointer min-h-[2.5rem] flex items-center",
                            neumorphStyles
                        )}
                    >
                        {displayText}
                    </div>
                }
            >
                <div className="space-y-2 overflow-y-auto p-2">
                    {options.map((opt) => (
                        <Checkbox
                            key={String(opt.value)}
                            label={opt.label}
                            checked={value.includes(opt.value)}
                            onChange={() => handleToggle(opt.value)}
                            disabled={
                                selectLimit
                                    ? !value.includes(opt.value) && value.length >= selectLimit
                                    : false
                            }
                        />
                    ))}

                    {selectLimit && (
                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
                            Máximo {selectLimit} seleccionados
                        </p>
                    )}
                </div>
            </Popover>
        </div>
    );
};
